/* eslint-disable max-len */
import React from 'react';

export default function Terms() {
  // noinspection HtmlUnknownTarget
  return (
    <div className="terms">
      <h1 className="heading heading--1">
        TERMS AND CONDITIONS
      </h1>

      <h2 className="heading heading--2">
        Introduction
      </h2>

      This website is owned and operated by Failbetter Games Limited("Failbetter Games"), a company registered in
      England and Wales(registered number 7121579). Our VAT number is 994 0172 06.

      <h2 className="heading heading--2">
        Definitions
      </h2>

      <p>
        "The Website" refers to the Fallen London website, and all associated services including the Living Stories
        interaction feature. "Fate" is our virtual currency purchased with real currency and occasionally provided as an
        in -game reward.
      </p>

      <p>
        Please read these terms and conditions carefully.
        {' '}
        Your accepting them in full is a condition of your use of the Website.
      </p>

      <p>
        We occasionally update these terms so please refer back to them in the future.
        If you have any questions about these terms and conditions, please contact us via email at
        {' '}
        <a href="mailto:enquiries@failbettergames.com">enquiries@failbettergames.com</a>
        ,
        and do not use the site until you are satisfied with and can accept these terms and conditions in full.
      </p>

      <h2 className="heading heading--2">
        Intellectual Property
      </h2>

      <p>
        The copyright and other intellectual property rights in all material on the Website are owned by us and must not
        be reproduced without our prior consent.
        {' '}
        (For guidance on fan works, please consult our
        {' '}
        <a href="https://www.failbettergames.com/fan-project-guidelines/">
          fan project guidelines
        </a>
        .)
      </p>

      <h2 className="heading heading--2">
        Availability
      </h2>

      <p>
        We take all reasonable steps to ensure that the Website is available 24 hours every day, 365 days per year.
        However, websites do sometimes encounter downtime due to server or other technical issues. We will not be liable
        if the Website is unavailable at any time.
      </p>

      <p>
        The Website may be temporarily unavailable due to issues such as system failure, maintenance or repair or for
        reasons beyond our control. Where possible we will try to provide advance warning of maintenance - related
        downtime, but shall not be obliged to do so.
      </p>

      <p>
        We take all reasonable steps to ensure that the information on the Website is correct. However, we do not
        guarantee its correctness or completeness. We may make changes to the material on the Website at any time and
        without notice.
      </p>

      <h2 className="heading heading--2">
        Privacy
      </h2>

      <p>
        See our full
        <a href="/privacy">
          privacy policy
        </a>
      </p>

      <h2 className="heading heading--2">
        Updates
      </h2>

      <p>
        The Website is under ongoing development. We make all reasonable efforts to ensure its behaviour is consistent
        and predictable. However, its content and functionality are subject to change at any time and at our discretion.
        We make no guarantee that any story element or game function will remain available and unchanged.
      </p>

      <h2 className="heading heading--2">
        Visitor Conduct
      </h2>

      <div>
        When using the Website you shall not post or send to or from the Website any material:
        <ul>
          <li>for which you have not obtained all necessary consents;</li>
          <li>
            that is discriminatory, obscene, pornographic, defamatory, in breach of confidentiality or privacy, liable
            to incite racial hatred, liable to cause annoyance or inconvenience to others, or which encourages or
            constitutes conduct that would be deemed a criminal offence, give rise to a civil liability, or otherwise be
            contrary to the laws of England and Wales;
          </li>
          <li>
            which is harmful in nature, including, and without limitation, computer viruses, Trojan horses, corrupted
            data, or other potentially harmful software or data.
          </li>
        </ul>
      </div>

      <div>
        Failbetter Games may suspend the accounts of any users it deems to be engaging in malicious or inappropriate
        conduct.
        Such conduct includes but is not limited to:

        <ul>
          <li>attempts to modify character statistics and possessions through exploits, including syncing exploits;</li>
          <li>
            attempts to manipulate character rankings or displays through means other than those intended by
            Failbetter Games;
          </li>
          <li>
            unauthorised reproduction or distribution of any of the Website's content, including but not limited to
            Fate-locked content;
          </li>
          <li>harassment or misinformation directed against other players or against employees of Failbetter Games;</li>
          <li>attempts to hack the Website;</li>
          <li>unauthorised use of automation or scripting to interact with the site;</li>
          <li>use of secondary accounts to harass other players or gain competitive advantage;</li>
          <li>denial of service attacks against the Website;</li>
          <li>any other breach of these terms of service.</li>
        </ul>
      </div>

      <p>
        Accounts may be suspended temporarily or removed permanently.
        {' '}
        No refunds will be available for any Fate purchases when an account is suspended.
        {' '}
        The decision of Failbetter in these matters is discretionary and final.
      </p>


      <h2 className="heading heading--2">
        Purchasing and using Virtual Currency
      </h2>

      <p>
        Players may buy Fate and use it on the Website. Fate is not refundable or returnable and may only be spent in
        Fallen London.
      </p>

      <p>
        Use of Fate for any purposes other than those authorised on the Website is a breach of these terms. You agree
        that Failbetter Games has the absolute right to manage, regulate, control, modify and / or eliminate Fate as it
        sees fit at its sole discretion.fate is not subject to refund, has no real monetary value and does not
        constitute real or virtual property of any kind. Accordingly, you do not have any ownership rights in Fate.
      </p>

      <h2 className="heading heading--2">
        Exceptional Friendship
      </h2>

      <p>
        Your Exceptional Friendship subscription begins as soon as we confirm your initial payment. Each month, we'll
        charge you the amount stated at the time of purchase.
      </p>

      <p>
        You can cancel the subscription at any time from your account settings page.doing so will stop the charge.
        You'll continue to receive the benefits of Exceptional Friendship until the end of the current billing term.
        We'll also cancel your subscription if you deactivate your account, or if we permanently suspend it for
        misconduct or any other reason.
      </p>

      <p>The fee is subject to change, but we'll notify you in advance if we increase it.</p>


      <h2 className="heading heading--2">
        No Buying or Selling Accounts or Items
      </h2>
      <p>
        All Fallen London accounts and virtual items are the property of Failbetter Games and players are only granted
        a limited, revocable licence to use accounts and virtual items.
      </p>

      <h2 className="heading heading--2">
        Exclusion of Liability
      </h2>

      <p>
        Neither we nor any other party(whether or not involved in producing, maintaining or delivering the Website),
        shall be liability or responsible for any kind of loss or damage that may result to you or a third party as a
        result of your or their use of our website. This exclusion shall include servicing or repair costs and, without
        limitation, any other direct, indirect or consequential loss, and whether in tort or contract or otherwise in
        connection with this Website.
      </p>

      <p>Nothing in these Terms shall exclude or limit liability for</p>
      <ol style={{ listStyleType: 'lower-roman' }}>
        <li>death or personal injury caused by negligence(as defined by the Unfair Contract Terms Act 1977);</li>
        <li>fraud;</li>
        <li>misrepresentation as to a fundamental matter; or</li>
        <li>any liability which cannot be excluded or limited under the law of England and Wales.</li>
      </ol>

      <h2 className="heading heading--2">
        Governing Jurisdiction
      </h2>

      These terms and conditions shall be governed by and construed in accordance with English law. Any disputes arising
      in connection with them are subject to the exclusive jurisdiction of England and Wales.


      <h2 className="heading heading--2">
        Our Details
      </h2>

      We are Failbetter Games, a company registered in England and Wales with the registration number of 7121579. Our
      registered office is Failbetter Games, 27 Old Gloucester Street, London, WC1N 3AX.

      We can be contacted by email at
      {' '}
      <a href="mailto:enquiries@failbettergames.com">enquiries@failbettergames.com</a>
      .
    </div>
  );
}

Terms.displayName = 'Terms';
